import React, { useMemo, useState } from "react";
import { initialState, ClusterContext } from "./ClusterContext";
import { IClusterProps, IMachineCentersClusterStatus, IClusterContext } from "./ClusterContextInterfaces";
import { setMachineCentersClusterStatusLocalStorage } from "utilities/storageUtilities";

export const ClusterProvider: React.FC<IClusterProps> = ({ children }) => {
    const [machineCentersClusterStatus, setMachineCentersClusterStatus] = useState<IMachineCentersClusterStatus[]>(
        initialState.machineCentersClusterStatus,
    );

    const providerValue = useMemo<IClusterContext>(() => {
        const handleSetMachineCentersClusterStatus = (value: IMachineCentersClusterStatus[]): void => {
            setMachineCentersClusterStatusLocalStorage(value);
            setMachineCentersClusterStatus(value);
        };

        return {
            machineCentersClusterStatus,
            handleSetMachineCentersClusterStatus,
        };
    }, [machineCentersClusterStatus]);

    return <ClusterContext.Provider value={providerValue}>{children}</ClusterContext.Provider>;
};
